import React, { useState } from 'react';

import DataSelect from '../common/DataSelect';
import { useGetMarketsQuery } from '../../redux/services/marketApi';

const SelectMarketInput = ({
  label = 'Market',
  ...props
}) => {
  return (
    <DataSelect
      useGetQuery={useGetMarketsQuery}
      label={label}
      {...props}
    />
  );
};

export default SelectMarketInput;